import * as Models from ".";
export interface IPartnerSettings {
	latitude: number;
	longitude: number;
	hasPartnerGeneratedCustomerNumber: boolean;
	partnerCustomerNumberRegularExpression: string;
	partnerCustomerNumberUiMask: string;
	useLeadNumber: boolean;
	leadNumberRegularExpression: string;
	leadNumberUiMask: string;
	creditCheckFlow: Models.CreditCheckFlowModel.ICreditCheckFlow;
	forceProductionEstimate: boolean;
	generatesScheduleA1: boolean;
	shouldUseDocuSignPhoneVerification: boolean;
}

export class PartnerSettings implements IPartnerSettings {
	latitude: number;
	longitude: number;
	hasPartnerGeneratedCustomerNumber: boolean;
	partnerCustomerNumberRegularExpression: string;
	partnerCustomerNumberUiMask: string;
	useLeadNumber: boolean;
	leadNumberRegularExpression: string;
	leadNumberUiMask: string;
	creditCheckFlow: Models.CreditCheckFlowModel.CreditCheckFlow;
	forceProductionEstimate: boolean;
	generatesScheduleA1: boolean;
	shouldUseDocuSignPhoneVerification: boolean;
}

